document.addEventListener('click', (e) => {
  // 1. 開くボタン（またはその子要素）がクリックされたか判定
  const openBtn = e.target.closest('.open-lightbox-trigger');
  const overlay = document.querySelector('.lightbox-overlay-unique');
  
  if (openBtn && overlay) {
    e.preventDefault();
    
    // data属性から内容を取得（なければ空文字）
    const title = openBtn.getAttribute('data-title') || '';
    const content = openBtn.getAttribute('data-content') || '';

    // Lightboxの空のタグに流し込む
    overlay.querySelector('b').innerText = title;
    overlay.querySelector('p').innerHTML = content;

    // 表示クラスを付与
    overlay.classList.add('is-active');
  }

  // 2. 閉じる判定（バツボタン or 背景クリック）
  if (overlay && overlay.classList.contains('is-active')) {
    const isCloseBtn = e.target.closest('.close-btn-unique');
    const isOverlayBackground = e.target === overlay;

    if (isCloseBtn || isOverlayBackground) {
      overlay.classList.remove('is-active');
      
      // アニメーションが終わる頃（300ms後）に中身を掃除しておくと丁寧
      setTimeout(() => {
        overlay.querySelector('b').innerText = '';
        overlay.querySelector('p').innerHTML = '';
      }, 300);
    }
  }
});

// 3. ESCキーで閉じる
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    const overlay = document.querySelector('.lightbox-overlay-unique');
    if (overlay && overlay.classList.contains('is-active')) {
      overlay.classList.remove('is-active');
    }
  }
});
